import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import PostsReducer from "./reducers/PostsReducer";
import thunk from "redux-thunk";
import { AuthReducer } from "./reducers/AuthReducer";
import todoReducers from "./reducers/Reducers";
import { reducer as reduxFormReducer } from "redux-form";

const middleware = applyMiddleware(thunk);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
};

// Combine your reducers with redux-persist
const rootReducer = combineReducers({
  posts: PostsReducer,
  auth: AuthReducer,
  todoReducers,
  form: reduxFormReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with persistedReducer
export const store = createStore(
  persistedReducer,
  composeEnhancers(middleware)
);

// Create the persisted store
export const persistor = persistStore(store);
